import { usePersonInfo } from '@/data/Content/PersonInfo';
import { useSettings } from '@/data/Settings';
import { getExternalId } from '@/data/utils/externalId';
import { TiktokClientPayload } from '@/pages/api/tracking/tiktok/types';
import { useTikTokClickIdentifiers } from 'presentation/events/hooks/useClickIdentifiers';
import { useTrackingStoreLocation } from 'presentation/events/hooks/useTrackingStoreLocation';
import { triggerTikTokConversionEvent } from 'presentation/events/services/tiktokService';
import { getReferrerForTracking, safeDecodeUrl } from 'presentation/events/utils/ga4Utils';
import { useCallback } from 'react';

interface TikTokEventParams {
	searchTerm: string;
	eventId: string;
	storeId: string;
}

export const useTrackSearchSubmitTikTok = () => {
	const { settings } = useSettings();
	const { userData } = settings;
	const { personInfo } = usePersonInfo();
	const { ttclid, ttp } = useTikTokClickIdentifiers();
	const storeLocation = useTrackingStoreLocation();

	const sendTiktokEvent = useCallback(
		({ searchTerm, eventId, storeId }: TikTokEventParams) => {
			if (userData?.ENABLE_TIKTOK_CALL !== 'true') return;

			const tiktokPayload: TiktokClientPayload = {
				event: 'Search',
				event_id: eventId,
				properties: {
					search_string: searchTerm,
				},
				user: {
					email: [personInfo?.email1 ?? ''],
					first_name: personInfo?.firstName,
					last_name: personInfo?.lastName,
					phone: [personInfo?.phone1 ?? ''],
					city: storeLocation?.city,
					state: storeLocation?.state,
					country: 'mx',
					external_id: [getExternalId()],
					locale: 'es-MX',
					zip_code: storeLocation?.zipCode,
					ttp,
					ttclid,
				},
				page: {
					url: safeDecodeUrl(location.href),
					referrer: getReferrerForTracking(),
				},
				storeId,
				test_event_code: userData?.TIKTOK_TEST_CODE,
			};

			triggerTikTokConversionEvent(tiktokPayload);
		},
		[
			ttp,
			storeLocation,
			personInfo?.email1,
			personInfo?.firstName,
			personInfo?.lastName,
			personInfo?.phone1,
			ttclid,
			userData?.ENABLE_TIKTOK_CALL,
			userData?.TIKTOK_TEST_CODE,
		]
	);

	return { sendTiktokEvent };
};
